import { Button, Flex, Modal } from "antd";
import { useState } from "react";
import { useDeleteLectureMutation } from "../../../../app/features/adminContent/adminContent.api";
import DeleteIcon from "../../../../assets/icons/DeleteIcon";
import EditIcon from "../../../../assets/icons/EditIcon";
import CustomModal from "../../../../components/CustomModal";
import CustomTable from "../../../../components/CustomTable";
import { toast } from "../../../../lib/toast";
import LectureForm from "./LectureForm";

type Props = {
  list: {
    contentType: string;
    durationSec: number;
    id: number;
    isPreview: boolean;
    title: string;
  }[];
};

export default function LectureList({
  list,
  courseId,
  sectionId,
}: Props & { courseId: number; sectionId: number }) {
  const [deleteLecture] = useDeleteLectureMutation();
  const [editLectureId, setEditLectureId] = useState<number | null>(null);

  const handleDeleteLecture = (lectureId: number) => {
    Modal.confirm({
      title: "Are you sure you want to delete this lecture?",
      content: "This action cannot be undone.",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        try {
          await deleteLecture(lectureId).unwrap();
          toast("success", "Lecture deleted successfully");
        } catch (error: any) {
          toast("error", error?.data?.message || "Failed to delete lecture");
        }
      },
    });
  };

  if (list?.length)
    return (
      <>
        <CustomTable
          dataSource={list}
          columns={[
            { title: "Title", dataIndex: "title" },
            {
              title: "Type",
              dataIndex: "contentType",
              //   render: (val) => capitalize(val),
              width: 200,
            },
            {
              title: "Action",
              width: 100,
              dataIndex: "id",
              align: "center",
              render: (id: number) => (
                <Flex gap={0} align="center" justify="center">
                  <Button
                    type="text"
                    size="small"
                    onClick={() => setEditLectureId(id)}
                    className="text-blue-600 hover:text-blue-700 px-2"
                    icon={<EditIcon className="text-green-600" />}
                  />
                  <Button
                    type="text"
                    danger
                    size="small"
                    icon={<DeleteIcon className="text-[#FF3838]" />}
                    onClick={() => handleDeleteLecture(id)}
                    className="px-2"
                  />
                </Flex>
              ),
            },
          ]}
          bordered
          rootClassName="p-0 shadow-none !mb-6"
          className="border-b"
        />

        {/* Edit Lecture Modal */}
        <CustomModal
          open={!!editLectureId}
          title="Edit Lecture"
          handleClose={() => setEditLectureId(null)}
          destroyOnClose
          size={800}
        >
          {editLectureId && (
            <LectureForm
              sectionId={sectionId}
              courseId={courseId}
              lectureId={editLectureId}
              onClose={() => setEditLectureId(null)}
            />
          )}
        </CustomModal>
      </>
    );
}
